import React from "react";
import {
  Title,
  Button,
  EmptyState,
  EmptyStatePrimary,
  EmptyStateIcon,
  EmptyStateBody,
  Spinner,
} from "@patternfly/react-core";
import SearchIcon from "@patternfly/react-icons/dist/js/icons/search-icon";

const NoMatchFound = (props) => {
  const { isFetching, onClearFilter } = props;

  function renderEmptyState() {
    if (isFetching) {
      return (
        <EmptyState style={{ backgroundColor: "#fff" }}>
          <EmptyStateIcon variant="container" component={Spinner} />
          <Title size="lg" headingLevel="h4">
            Loading
          </Title>
        </EmptyState>
      );
    } else {
      return (
        <EmptyState style={{ backgroundColor: "#fff" }}>
          <EmptyStateIcon icon={SearchIcon} />
          <Title size="lg" headingLevel="h4">
            No results
          </Title>
          <EmptyStateBody>
            No results found. Please clear all filters or create new entry.
          </EmptyStateBody>
          <EmptyStatePrimary>
            <Button variant="link" onClick={onClearFilter}>
              Clear all filters
            </Button>
          </EmptyStatePrimary>
        </EmptyState>
      );
    }
  }
  return renderEmptyState();
};

export default NoMatchFound;
